import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { TransitionGroup, Transition, CSSTransition } from 'react-transition-group';

// const WetProjectGrid = (props) => {
class WetProjectGrid extends React.Component {
    constructor(props) {
        super(props);
        let currentProjectIndex = this.props.projects.findIndex(project => project.path === props.path);
        this.gridImages = this.props.projects[currentProjectIndex].gridImages;
    }

    render() {


        return (
            <div>
                <div className="project-slide"></div>
                <div className="project-grid wet-project container">
                    <div className="flex">
                        {/*<img className="grid-img-1" src="/assets/img/homes/wet/03.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-1', asset: this.gridImages[2], sizes: ''}}/>
                        <div className="grid-col-1">
                            {/*<img className="grid-img-2" src="/assets/img/homes/wet/02.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-2', asset: this.gridImages[1], sizes: ''}}/>
                            <svg className="grid-svg-1" width="295" height="168" viewBox="0 0 295 168">
                                <text className="polygon-text barlow-it" x="0" y="0">
                                    <tspan x="0" dy="24">Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet.</tspan>
                                    <tspan x="0" dy="24">Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet. Wet.</tspan>
                                </text>
                            </svg>
                        </div>
                    </div>
                    <div className="flex">
                        {/*<img className="grid-img-3" src="/assets/img/homes/wet/04.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-3', asset: this.gridImages[3], sizes: ''}}/>
                        <div className="grid-col-5">
                            {/*<img className="grid-img-4" src="/assets/img/homes/wet/05.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-4', asset: this.gridImages[4], sizes: ''}}/>
                            <svg className="grid-svg-2" x="0px" y="0px"
                                 width="792" height="12" viewBox="0 0 792 12">
                                <defs>
                                    <pattern id="letter-pattern2" x="0" y="-3" width="24" height="10" viewBox="0 0 24 10" patternUnits="userSpaceOnUse">
                                        <text className="polygon-text barlow-it" x="0" y="10">w</text>
                                    </pattern>
                                </defs>
                                <rect x="0" y="0" width="792" height="10" fill="url(#letter-pattern2)" />
                            </svg>
                        </div>
                    </div>
                    <svg className="grid-svg-3" x="0px" y="0px"
                         width="792" height="12" viewBox="0 0 792 12">
                        <defs>
                            <pattern id="letter-pattern" x="0" y="0" width="24" height="10" viewBox="0 0 24 10" patternUnits="userSpaceOnUse">
                                <text className="polygon-text barlow-it" x="0" y="10">e</text>
                            </pattern>
                        </defs>
                        <rect x="0" y="0" width="631" height="20" fill="url(#letter-pattern)" />
                    </svg>
                    {/*<img className="grid-img-5" src="/assets/img/homes/wet/06.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-5', asset: this.gridImages[5], sizes: ''}}/>
                    <div className="flex flex-container-1">
                        <svg className="grid-svg-4" x="0px" y="0px" width="303" height="240" viewBox="0 0 303 240">
                            <defs>
                                <pattern id="wet-pattern" x="0" y="0" width="34" height="60" viewBox="0 0 34 50" patternUnits="userSpaceOnUse">
                                    <text className="wet-text yrsa-li" x="0" y="4" fill="#af2100">
                                        <tspan x="0" dy="24">We</tspan>
                                        <tspan x="13" dy="24">t.</tspan>
                                    </text>
                                </pattern>
                            </defs>
                            <rect x="0" y="128" width="33" height="110" fill="url(#wet-pattern)"></rect>
                            <rect x="136" y="66" width="33" height="172" fill="url(#wet-pattern)"></rect>
                            <rect x="272" y="0" width="33" height="240" fill="url(#wet-pattern)"></rect>
                        </svg>
                        {/*<img className="grid-img-6" src="/assets/img/homes/wet/07.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-6', asset: this.gridImages[6], sizes: ''}}/>
                    </div>
                    <div className="flex">
                        {/*<img className="grid-img-7" src="/assets/img/homes/wet/08.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-7', asset: this.gridImages[7], sizes: ''}}/>
                        {/*<img className="grid-img-8" src="/assets/img/homes/wet/09.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-8', asset: this.gridImages[8], sizes: ''}}/>
                    </div>
                    <div className="flex">
                        <div className="grid-col-2">
                            <svg className="grid-svg-5" x="0px" y="0px" width="360" height="249" viewBox="0 0 360 249">
                                <defs>
                                    <pattern id="wet-pattern2" x="0" y="0" width="360" height="60" viewBox="0 0 360 50" patternUnits="userSpaceOnUse">
                                        <text className="wet-text wet-text2 yrsa-li" x="0" y="4" fill="#af2100">
                                            <tspan x="0">W</tspan>
                                            <tspan x="0" dx="169">e</tspan>
                                            <tspan x="0" dx="338">t</tspan>
                                        </text>
                                    </pattern>
                                </defs>
                                <rect x="0" y="0" width="360" height="250" fill="url(#wet-pattern2)"></rect>
                            </svg>
                            {/*<img className="grid-img-9" src="/assets/img/homes/wet/11.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-9', asset: this.gridImages[10], sizes: ''}}/>
                        </div>
                        <div className="grid-col-3">
                            {/*<img className="grid-img-10" src="/assets/img/homes/wet/10.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-10', asset: this.gridImages[9], sizes: ''}}/>
                            <svg className="grid-svg-6" x="0px" y="0px" width="342" height="359" viewBox="0 0 342 359">
                                <text className="wet-text wet-text2 yrsa-li" x="0" y="6" fill="#af2100">
                                    <tspan x="0">W</tspan>
                                    <tspan x="0" dx="169">e</tspan>
                                    <tspan x="0" dx="338">t</tspan>
                                    
                                    <tspan x="0" dy="61">W</tspan>
                                    <tspan x="0" dx="169">e</tspan>
                                    <tspan x="0" dx="338">t</tspan>

                                    <tspan x="0" dy="76">W</tspan>
                                    <tspan x="0" dx="169">e</tspan>
                                    <tspan x="0" dx="338">t</tspan>

                                    <tspan x="0" dy="96">W</tspan>
                                    <tspan x="0" dx="169">e</tspan>
                                    <tspan x="0" dx="338">t</tspan>

                                    <tspan x="0" dy="120">W</tspan>
                                    <tspan x="0" dx="169">e</tspan>
                                    <tspan x="0" dx="338">t</tspan>
                                </text>
                            </svg>
                        </div>
                    </div>
                    {/*<img className="grid-img-11" src="/assets/img/homes/wet/12.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-11', asset: this.gridImages[11], sizes: ''}}/>
                    <div className="flex">
                        <div className="grid-col-4">
                            <svg className="grid-svg-7" x="0px" y="0px" width="250" height="268" viewBox="0 0 250 268">
                                <defs>
                                    <pattern id="wet-pattern3" x="0" y="0" width="360" height="26" viewBox="0 0 360 16" patternUnits="userSpaceOnUse">
                                        <text className="wet-text3 yrsa-li" x="0" y="3" fill="#828282">
                                            <tspan x="0">Wet.</tspan>
                                            <tspan x="0" dx="36">Wet.</tspan>
                                            <tspan x="0" dx="219">Wet.</tspan>
                                        </text>
                                    </pattern>
                                </defs>
                                <rect x="0" y="0" width="250" height="268" fill="url(#wet-pattern3)"></rect>
                            </svg>
                            {/*<img className="grid-img-12" src="/assets/img/homes/wet/14.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-12', asset: this.gridImages[13], sizes: ''}}/>
                            {/*<img className="grid-img-13" src="/assets/img/homes/wet/15.jpg" alt=""/>*/}
                            <GridImage params={{className: 'grid-img-13', asset: this.gridImages[14], sizes: ''}}/>
                        </div>
                        {/*<img className="grid-img-14" src="/assets/img/homes/wet/13.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-14', asset: this.gridImages[12], sizes: ''}}/>
                    </div>
                    <div className="flex credits-container">
                        <div className="credits desktop">
                            <span className="credits-title red">Credits</span>
                            <ul className="no-style">
                                <li><span className="red barlow-me">Project</span> Wet</li>
                                <li><span className="red barlow-me">Photographer</span> Coco Amardeil</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(WetProjectGrid));


// WEBPACK FOOTER //
// ./src/components/WetProjectGrid.js